module.exports = __webpack_public_path__ + "a2122bb228a41fcf955e6f95a2faf671.png";